<script lang="ts">
	import { NodeViewWrapper } from 'svelte-tiptap';
	import DragAndDropWrapper from '$lib/components/TextEditor/Components/DragAndDropWrapper/DragAndDropWrapper.svelte';
	import type { NodeViewProps } from '@tiptap/core';
	import InsertWidget from '$textEditor/Components/Blocks/Widget/InsertWidget.svelte';
	import type { Post, Widget } from '$lib/api/rpc';
	import { onMount } from 'svelte';
	import { getQuickPollURL } from '$lib/utils/getQuickPollURL';
	import { page } from '$app/stores';

	export let node: NodeViewProps['node'];
	export let deleteNode: () => void;
	export let updateAttributes: NodeViewProps['updateAttributes'];

	if (!$page.data.respHub || !$page.data.respSessionHubUser)
		throw new Error('TextEditor  widget: Missing hub or user');

	const hub = $page.data.respHub.hub;
	const user = $page.data.respSessionHubUser.user;

	let modalOpen = node.attrs.isOpen;

	let post: Post = node.attrs.post;

	const selectWidget = (widget: Widget) => {
		post = {
			type: 'widget',
			oembed: {
				html: widget.tag,
				width: widget.width,
				height: widget.height,
			},
		} as Post;
		updateAttributes({ post, isOpen: false });
		modalOpen = false;
	};

	onMount(() => {
		post = node.attrs.post;
		if (!post) {
			updateAttributes({ isOpen: true });
			modalOpen = true;
		}
	});
</script>

<NodeViewWrapper>
	{#if modalOpen}
		<InsertWidget {selectWidget} />
	{:else}
		<DragAndDropWrapper on:delete={deleteNode}>
			<div class="widget">
				{#if post?.oembed?.html}
					{@html post?.oembed?.html}
				{:else}
					<iframe
						src={getQuickPollURL({ hub, user, quickPollUrl: post.etc.widget?.url })}
						title="QuickPoll" />
				{/if}
			</div>
		</DragAndDropWrapper>
	{/if}
</NodeViewWrapper>

<style>
	.widget :global(iframe) {
		min-block-size: 600px;
		inline-size: 100%;
		border: none;
	}
</style>
